import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**
 * Класс данных уведомлений.
 */
export class NotifyData {
  /**
   * Дата и время уведомления.
   */
  public Time: DateType = new Date();

  /**
   * Внутренний ИД уведомления.
   */
  public Id: number = 0;

  /**
   * Сосотояние уведомления.
   */
  public State: number = 0;

  /**
   * Заголовок уведомления.
   */
  public Subject: string = "";

  /**
   * Короткий текст уведомления.
   */
  public ShortText: string = "";

  /**
   * Изображение уведомления.
   */
  public Photo: string = "";

  /**
   * Информация о пользователе. (не используется).
   */
  public PersonInfo: string = "";

  /**
   * Уникальный ИД уведомления. (не используется).
   */
  public ReferenceId: string = "";

  /**
   * Текст уведомления.
   */
  public Text: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      // парсим краткую информацию уведомления
      this.Time = parseDate(src.DateTime, new Date());
      this.Id = src.Id ?? 0;
      this.Subject = src.Subject ?? "";
      this.ShortText = src.ShortText ?? "";
      this.Photo = src.Photo ?? "";
      this.State = src.State ?? 0;
      // парсим подробную информацию уведомления
      this.Text = src.Text ?? "";
    }
  }
}
